import { render, staticRenderFns } from "./MilkVatsOverview.vue?vue&type=template&id=717915a6&"
import script from "./MilkVatsOverview.vue?vue&type=script&lang=ts&"
export * from "./MilkVatsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports